import { LeagueRewards } from "../components/LeagueRewards";
import { ABtesting } from "../containers/ABtesting";
import { Alliance } from "../containers/Alliance";
import { Alliances } from "../containers/Alliances";
import { AllianceWars } from "../containers/AllianceWars";
import { AllianceWarAlliances } from "../containers/AllianceWars/Alliances";
import { AllianceWarPreparations } from "../containers/AllianceWars/Preparations";
import { AllianceWarPreparationsDetail } from "../containers/AllianceWars/Preparations/detail";
import { Analytics } from "../containers/Analytics";
import { Bots } from "../containers/Bots";
import { BountyPacks } from "../containers/BountyPacks";
import { BundleExporter } from "../containers/BundleExporter";
import { BundleExplorer } from "../containers/Bundles/components/BundleExplorer";
import { EditFile } from "../containers/Bundles/components/EditFile";
import { Chests } from "../containers/Chests";
import { DashboardUser } from "../containers/DashboardUsers";
import { Environments } from "../containers/Environments";
import { FillTournaments } from "../containers/FillTournaments";
import { GameEvents } from "../containers/GameEvents";
import { GameEvent } from "../containers/GameEvents/singleEvent";
import { ItemsExplorer } from "../containers/Items";
import { Layouts } from "../containers/Layouts";
import {Maintenance} from "../containers/Maintenance";
import { AttackMapEditor } from "../containers/MapEditor/Attack";
import { DefenseMapEditor } from "../containers/MapEditor/Defense";
import { News } from "../containers/News";
import { Player } from "../containers/Player";
import { Players } from "../containers/Players";
import { Purchases } from "../containers/Purchases";
import { IAPs } from "../containers/Shop/IAPs";
import { ShopPacks } from "../containers/Shop/Packs";
import { Simulation } from "../containers/Simulation";
import { Task } from "../containers/Tasks/task";
import { Tasks } from "../containers/Tasks/tasks";
import { Tools } from "../containers/Tools";
import { Translations } from "../containers/Translations";
import { UserImporter } from "../containers/UserImporter";
import { UserSettings } from "../containers/UserSettings";
import { UserReport } from "../containers/UserReport";
import {ChatManagement} from "../containers/ChatMaintenance";
import {BannerManagement} from "../containers/Banner";
import {UnfinishedTutorial} from "../containers/EditPlayers/unfinishedTutorial";
import {SapphireCheatedUser} from "../containers/EditPlayers/sapphireCheatedUser";
import {RedisPublish} from "../containers/RedisPublish";
import Roles from "../containers/Roles";
import {FixMira} from "../containers/EditPlayers/fixMira";
import {BattleReport} from "../containers/Report/BattleReport";
import {InactiveUser} from "../containers/EditPlayers/inactiveUser";
import {DuplicateName} from "../containers/EditPlayers/duplicateName";
import {InactiveCacheV2} from "../containers/EditPlayers/inactiveCacheV2";
import {GetStrongBase} from "../containers/EditPlayers/getStrongBase";
import {RubyBattle} from "../containers/Report/RubyBattle";
import {RubyCompetition} from "../containers/RubyCompetition/RubyCompetition";
import {RWBReport} from "../containers/Report/RWBReport";
import {BroadcastMail} from "../containers/BroadcastMail/broadcastMail";
import {VerifyBuildings} from "../containers/EditPlayers/verifyBuilding";
import {RWBInternalTeam} from "../containers/Report/RWBInternalTeam";
import {LuckyWheel} from "../containers/LuckyWheel/luckyWheel";
import { ECSDeployment } from "../containers/Deployment";
import {SquadDonation} from "../containers/SquadDonation/squadDonation";
import { GameGeneralEvent } from "../containers/GameGeneralEvent";
import { TournamentBattleLogs } from "../containers/Tournament/BattleLogs";
import { TournamentBattleLogDetail } from "../containers/Tournament/BattleLogs/detail";
import { TournamentEnvironments } from "../containers/Tournament/Environments";
import { TournamentEnvironmentDetail } from "../containers/Tournament/Environments/detail";
import { TournamentLayouts } from "../containers/Tournament/Layouts";
import { TournamentLayoutDetail } from "../containers/Tournament/Layouts/detail";

export const Routes = [
    {
        path: "/game_general_event",
        component: GameGeneralEvent,
        access: "game_general_event",
    },
    {
        path: "/squad-donation",
        component: SquadDonation,
        access: "ruby_battle"
    },
    {
        path: "/rwb-internal-team",
        component: RWBInternalTeam,
        access: "ruby_battle"
    },
    {
        path: "/lucky-wheel",
        component: LuckyWheel,
        access: "ruby_battle"
    },
    {
        path: "/verify-building",
        component: VerifyBuildings,
        access: "ruby_battle"
    },
    {
        path: "/admin-mail",
        component: BroadcastMail,
        access: "ruby_battle"
    },
    {
        path: "/rwb-map-name",
        component: RWBReport,
        access: "ruby_battle"
    },
    {
        path: "/ruby-competition",
        component: RubyCompetition,
        access: "ruby_battle"
    },
    {
        path: "/ruby-battle",
        component: RubyBattle,
        access: "ruby_battle"
    },
    {
        path: "/strong-base",
        component: GetStrongBase,
        access: "inactive_user"
    },
    {
        path: "/inactive-cache",
        component: InactiveCacheV2,
        access: "inactive_user"
    },
    {
        path: "/duplicate-name",
        component: DuplicateName,
        access: "inactive_user"
    },
    {
        path: "/inactive-user",
        component: InactiveUser,
        access: "inactive_user"
    },
    {
        path: "/battle-report",
        component: BattleReport,
        access: "battle_report",
    },
    {
        path: "/fix-mira",
        component: FixMira,
        access: "fix_mira",
    },
    {
        path: "/roles",
        component: Roles,
        access: "roles",
    },
    {
        path: "/publish_redis",
        component: RedisPublish,
        access: "cheat_sapphire",
    },
    {
        path: "/cheat-sapphire",
        component: SapphireCheatedUser,
        access: "cheat_sapphire",
    },
    {
        path: "/unfinished-tutorial",
        component: UnfinishedTutorial,
        access: "unfinished_tutorial",
    },
    {
        path: "/banners",
        component: BannerManagement,
        access: "banners",
    },
    {
        path: "/chat/management",
        component: ChatManagement,
        access: "chat",
    },
    {
        path: "/user-report",
        component: UserReport,
        access: "user_report",
    },
    {
        path: "/maintenance",
        component: Maintenance,
        access: "maintenance",
    },
    {
    path: "/abtesting",
    component: ABtesting,
    access: "ab_testing",
}, {
    path: "/ghost_bases",
    component: Bots,
    access: "bots",
}, {
    path: "/simulation_anomalies",
    component: Simulation,
    access: "simulation_anomalies",
}, {
    path: "/bundle-exporter",
    component: BundleExporter,
    access: "sheets_exporter",
}, {
    path: "/fill_tournament",
    component: FillTournaments,
    access: "tournaments",
}, {
    path: "/tournament/battle-logs/:battleId",
    component: TournamentBattleLogDetail,
    access: "tournaments",
}, {
    path: "/tournament/battle-logs",
    component: TournamentBattleLogs,
    access: "tournaments",
}, {
    path: "/tournament/layouts/:layoutId",
    component: TournamentLayoutDetail,
    access: "tournaments",
}, {
    path: "/tournament/layouts",
    component: TournamentLayouts,
    access: "tournaments",
}, {
    path: "/tournament/environments/:environmentId",
    component: TournamentEnvironmentDetail,
    access: "tournaments",
}, {
    path: "/tournament/environments",
    component: TournamentEnvironments,
    access: "tournaments",
}, {
    path: "/translations",
    component: Translations,
    access: "translations",
}, {
    path: "/alliance_wars/seasons",
    component: AllianceWars,
    access: "alliance_wars",
}, {
    path: "/alliance_wars/alliances",
    component: AllianceWarAlliances,
    access: "alliance_wars",
}, {
    path: "/alliance_wars/preparations/:seasonId",
    component: AllianceWarPreparationsDetail,
    access: "alliance_wars",
}, {
    path: "/alliance_wars/preparations",
    component: AllianceWarPreparations,
    access: "alliance_wars",
}, {
    path: "/alliance_wars",
    component: AllianceWars,
    access: "alliance_wars",
}, {
    path: "/game_events/:gameEventKey",
    component: GameEvent,
    access: "game_events",
}, {
    path: "/game_events",
    component: GameEvents,
    access: "game_events",
}, {
    path: "/tasks/new",
    component: Task,
    access: "tasks",
}, {
    path: "/tasks",
    component: Tasks,
    access: "tasks",
}, {
    path: "/items/:type",
    component: ItemsExplorer,
    access: null,
}, {
    path: "/user_import",
    component: UserImporter,
    access: null,
}, {
    path: "/analytics/:page",
    component: Analytics,
    access: null,
}, {
    path: "/league_rewards",
    component: LeagueRewards,
    access: null,
}, {
    path: "/briefcase",
    component: Chests,
    access: null,
}, {
    path: "/bounties/packs",
    component: BountyPacks,
    access: null,
}, {
    path: "/players/:playerId/:activeTab",
    component: Player,
    access: null,
}, {
    path: "/players/:playerId",
    component: Player,
    access: null,
}, {
    path: "/players",
    component: Players,
    access: null,
}, {
    path: "/dashboard-users", // dasboard users
    component: DashboardUser,
    access: null,
}, {
    path: "/alliances/:allianceId/:activeTab",
    component: Alliance,
    access: null,
}, {
    path: "/alliances/:allianceId",
    component: Alliance,
    access: null,
}, {
    path: "/alliances",
    component: Alliances,
    access: null,
}, {
    path: "/map/edit/:bundleId/attack/:mapId",
    component: AttackMapEditor,
    access: null,
}, {
    path: "/map/edit/:bundleId/defense/:mapId",
    component: DefenseMapEditor,
    access: null,
}, {
    path: "/tools",
    component: Tools,
    access: null,
}, {
    path: "/news",
    component: News,
    access: null,
}, {
    path: "/user/settings",
    component: UserSettings,
    access: null,
}, {
    path: "/layouts",
    component: Layouts,
    access: null,
}, {
    path: "/bundle/item/:key",
    component: EditFile,
    access: null,
    exact: true
}, {
    path: "/bundle/:folder1?/:folder2?/:folder3?/:folder4?/:folder5?/:folder6?",
    component: BundleExplorer,
    access: null,
}, {
    path: "/purchase_changes",
    component: Purchases,
    access: "purchases"
}, {
    path: "/environments",
    component: Environments,
    access: "environments"
}, {
    path: "/shop/iaps",
    component: IAPs,
    access: "shop"
}, {
    path: "/shop/packs",
    component: ShopPacks,
    access: "shop"
}, {
    path: "/ecs-deployment",
    component: ECSDeployment,
    access: "ecs_deployment",
}];
